module.exports = __webpack_public_path__ + "static/media/3DPPA32.f87239f1.jpg";